const { fetchAuthorizedJsonApi, fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');

/**
 * @return Promise that returns the list of available comics
 */
function fetchComics(apiUrl, token) {
  const headers = {};

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v1/comics',
    query: { lang: getApiLanguage() },
    headers,
    expectedStatus: 200,
    description: 'Fetching comics',
  });
}

function fetchReadComics(apiUrl, token) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: 'v1/comics/readComics',
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching read comics',
  });
}

/**
 * @return Promise that marks an existing comic as read
 */
function readComic(apiUrl, token, comicId) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: `v1/comics/${comicId}/read`,
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Requesting reward for reading the comic',
  });
}

module.exports = {
  fetchComics,
  fetchReadComics,
  readComic,
};
